import { Injectable } from '@angular/core';
import {Http, Response, RequestOptions, HttpModule, Headers, RequestOptionsArgs} from '@angular/http';
import { UserFriendlyMsgs } from '../../app.user-msgs'
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class LocationdocumentsService {
  load;
  url = environment.configURI;
  private locationDocsURL = "/documents/GetDocumentTypesByCategory?Category=LOCATION";

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  listOfLocDocs(agentId):any {
    return this.httpClient.get(`${this.url}${this.locationDocsURL}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  getLocationListDocuments(locationId) {
      let vendor_id = localStorage.getItem("AgentId")
      let role = parseInt(localStorage.getItem("RoleVal"))
        if (role === 8) {
          return this.httpClient.get(this.url+'/client/location/'+locationId+"/"+vendor_id +'/documents').catch(this.userFriendlyMsgs.errorHandler);
        } else {
          return this.httpClient.get(this.url+'/location/'+locationId+"/"+vendor_id+'/documents').catch(this.userFriendlyMsgs.errorHandler);
        }
  }

  submitDocumentVal(body) {
    return this.httpClient.post(this.url+'/locations/documents', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  updateDueDocuments(body) {
    return this.httpClient.put(this.url+'/locations/document/'+ body.docId, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  deleteDueDocuments(body, agentId) {
    return this.httpClient.delete(this.url+'/locations/document/'+ agentId  + '/' + body._id).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/locationdocuments/locationdocuments.service.ts